export const todayEastern = () =>
  new Date().toLocaleDateString('en-CA', { timeZone: 'America/Detroit' });

export const todayEasternDisplay = () =>
  new Date().toLocaleDateString('en-US', {
    timeZone: 'America/Detroit',
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
  });

export const toEasternTime = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-US', {
    timeZone: 'America/Detroit',
    month: 'short', day: 'numeric', year: 'numeric',
    hour: 'numeric', minute: '2-digit', hour12: true,
  });
};

export const toEasternDateShort = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-US', {
    timeZone: 'America/Detroit',
    month: 'short', day: 'numeric', year: 'numeric',
  });
};

// Alias used by BrandVoicePage
export const toEasternDate = toEasternDateShort;

export function timeAgo(iso) {
  if (!iso) return '';
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60_000);
  const hrs  = Math.floor(mins / 60);
  const days = Math.floor(hrs / 24);
  if (days > 1)  return `${days} days ago`;
  if (days === 1) return 'yesterday';
  if (hrs > 0)   return `${hrs}h ${mins % 60}m ago`;
  if (mins > 0)  return `${mins}m ago`;
  return 'just now';
}
